/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  VueFormatterFeatureServiceInterface,
  LocaleService,
} from '../../types/feature-service-types';
import { createContext } from 'react';

type ContentContextState = {
  content: any;
  vueFormatterService: VueFormatterFeatureServiceInterface;
  localeService: LocaleService;
};

export const ContentContext = createContext<Partial<ContentContextState>>({});
